import { htmlDecimalEncode } from '@/utils/htmlDecode';
export default function transfer(json) {
  const { count, des = '', logo, mon, much, tit = '' } = json;

  const xmlHeader = `<msg brief="企点结构化消息" serviceID="115" msgName="e-commerce-goods" background="#FFFFFFFF">
  <linear background="#FFFFFFFF" width="-2" height="-2" margin="24,24,24,24" margin.pc="12,12,12,12" cornerRadius="12" orientation="vertical">
  <linear width="-2" height="-2">
  <linear width="-2" height="-2">`;

  const xmlFooter = `</linear>
  </linear>
  </linear>
  </linear>
  </msg>`;
  let xmlStr = '';
  const titStr = tit ? `<text width="304" height="-2" width.pc="152" weight="500" size="28" size.pc="10" style="bold" color.pc="#262d3d" maxLine="1" lineSpace="0" lineSpace.pc="5" text="${tit}"/>
  ` : '';
  const desStr = des ? `<text width="304"  height="-2" width.pc="152" margin="0,22,0,0" margin.pc="0,0,0,0" size="24" size.pc="8" color="#FF78849E" color.pc="0xFF78849E" maxLine="1" text="${des}"/>
  ` : '';
  const logoStr = logo ? `<image name="onlineGoods" width="144" width.pc="72" height="144" height.pc="72" src="${htmlDecimalEncode(logo)}"></image>`
    : '';
  const monStr = isNumSet(mon) ? `  <text width="160"  width.pc="15" height="-2" margin="0,32,0,0" margin.pc="0,2,0,0" size="24" size.pc="8" color="#FFFF8147" color.pc="0xFFFF8147" text="${mon}" />
  ` : '';
  const countStr = isNumSet(count)  ? `  <text width="120"  width.pc="15" height="-2" margin="0,32,0,0" margin.pc="0,2,0,0" size="24" size.pc="8" color="#68010B32" color.pc="0x68010B32" text="x ${count}"></text>
  ` : '';
  const muchStr = isNumSet(much) ? `<text width="304" width.pc="152" height="-2" margin="10,4,0,0" margin.pc="0,2,0,0" size="24" size.pc="8" color="#68010B32" color.pc="0x68010B32" text="${much}件已售" maxLine="1"/>`
    : '';
  xmlStr = `${xmlHeader}
  ${logoStr}
  <linear width="-2" height="-2" margin="16,0,0,0" margin.pc="8,0,0,0" gravity="top" orientation="vertical">
  ${titStr}${desStr}
  <linear orientation="horizontal" gravity="left">
  ${monStr}${countStr}
  </linear>
  </linear>
  <linear width="-2" height="-2" margin.pc="8,0,0,0" orientation="vertical" gravity="bottom">
  ${muchStr}
  ${xmlFooter}
  `;
  return xmlStr;
};

function isNumSet(num) {
  return  num || String(num) === '0';
}
